import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-6 mb-2" }
const _hoisted_3 = { class: "col-6 mb-2" }
const _hoisted_4 = { class: "col-6 mb-2" }
const _hoisted_5 = { class: "col-6 mb-2" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "col-6 mb-2" }
const _hoisted_8 = { class: "col-6 mb-2" }
const _hoisted_9 = { class: "col-6 mb-2" }
const _hoisted_10 = { class: "col-6 mb-2" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-6 mb-2" }
const _hoisted_13 = { class: "col-6 mb-2" }
const _hoisted_14 = { class: "col-6 mb-2" }
const _hoisted_15 = { class: "col-6 mb-2" }
const _hoisted_16 = { class: "col-6 mb-2" }
const _hoisted_17 = { class: "col-6 mb-2" }
const _hoisted_18 = { class: "col-6 mb-2" }
const _hoisted_19 = { class: "col-6 mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "col-6 mb-2"
}
const _hoisted_21 = { class: "col-6 mb-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "mb-3 pl-3 pr-3" }
const _hoisted_24 = { class: "same-line" }
const _hoisted_25 = { class: "text-dark font-weight-bold" }
const _hoisted_26 = { class: "shadow-0 table table-sm mb-5" }
const _hoisted_27 = { class: "text-dark font-weight-bold" }
const _hoisted_28 = { class: "text-dark font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelAndValue = _resolveComponent("LabelAndValue")!
  const _component_OnlyValue = _resolveComponent("OnlyValue")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.firstName',
          value: _ctx.person.familyName,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.lastName',
          value: _ctx.person.firstName,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.maritalState',
          value: _ctx.person?.currentMaritalStatus?.type?.value
        ? _ctx.$t(`demand.party.statusMarital.${_ctx.person.currentMaritalStatus.type.value}`)
        : ''
        ,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.birthday',
          value: `${_ctx.person.birthDate} ${_ctx.getYearsOfDate(
        _ctx.formatDateToMoment(_ctx.person.birthDate, '-')
      )} ${_ctx.$t('main.years')}`,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.citizenship',
          value: _ctx.$t(`demand.party.country.${_ctx.person.nationality.type.value}`),
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.address',
          value: _ctx.adressType(_ctx.person.addresses),
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"]),
        _createVNode(_component_OnlyValue, {
          class: "q-mt-xs",
          value: _ctx.adressStreetAndStreetNumber(_ctx.person.addresses) + '-',
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "div-value-style"]),
        _createVNode(_component_OnlyValue, {
          class: "q-mt-xs",
          value: _ctx.adressPostalCodeAndCity(_ctx.person.addresses),
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.phoneNumber',
          value: _ctx.contacts?.get(_ctx.ContactType?.PHONE_CONTACT),
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.email',
          value: _ctx.contacts?.get(_ctx.ContactType?.EMAIL_CONTACT),
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.profession',
          value: _ctx.primaryJob?.jobName || '-',
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.professionalSituation',
          value: _ctx.professionalSituationLabel,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'main.labels.contractType',
          value: _ctx.contractTypeLabel,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'main.labels.employerSeniority',
          value: _ctx.employerSeniority,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.addressStatus',
          value: _ctx.addressStatusLabel,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'main.labels.renewal',
          value: _ctx.renewalClientLabel,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'main.labels.isCfClient',
          value: _ctx.cfClientLabel,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.childrenCount',
          value: _ctx.childrenCount,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ]),
      (_ctx.isManagerRole)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_LabelAndValue, {
              "i18n-key": 'summaryPanel.customer.managedCompany',
              value: _ctx.managedCompanyName,
              oneLine: true,
              "value-style": _ctx.valueStyle,
              "label-style": _ctx.labelStyleItem,
              "div-value-style": _ctx.divValueStyle
            }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_LabelAndValue, {
          "i18n-key": 'summaryPanel.customer.activity',
          value: _ctx.person.jobs?.find((el) => !!el)?.activity?.type?.value
        ? _ctx.$t(
          `demand.party.jobActivity.${_ctx.person.jobs.find((el) => !!el).activity.type.value
          }`
        )
        : '-'
        ,
          oneLine: true,
          "value-style": _ctx.valueStyle,
          "label-style": _ctx.labelStyleItem,
          "div-value-style": _ctx.divValueStyle
        }, null, 8, ["value", "value-style", "label-style", "div-value-style"])
      ])
    ]),
    (!_ctx.hideClassification && (!_ctx.order ||(_ctx.order!=='order')))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          ((_ctx.rows && _ctx.rows.length != 0))
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 0,
                "default-opened": "",
                "expand-icon-toggle": "",
                "header-class": "align-items-center justify-content-between mb-3 mt-3",
                class: "bg-secondary"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.capitalize(
            _ctx.$t("middleOffice.party.organization.section.classification").toLowerCase()
          )), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.person.classifications, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('main.type')) + ": ", 1),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("picklists.partyClassificationType." + item.classType)), 1)
                        ]),
                        _createElementVNode("table", _hoisted_26, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("task.labels.value")), 1),
                              _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("main.labels.classificationDate")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.$t(`demand.party.partyClass.${item.partyClass?.resourceUid}`)), 1),
                              _createElementVNode("td", null, _toDisplayString((item.classificationDate)), 1)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}